// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__3HI6K","required":"Label_required__2XuCR"};